export default __webpack_public_path__ + "static/06-the-world-mobile-f4a6e678698313c9f1eb988799c6d31e.svg";